export const containerStyles = `flex flex-col items-center h-full w-full`

export const footerBackgroundImageContainerStyles = `w-full`

export const bodyContainerStyles = `flex flex-col items-center justify-center w-full grow`

export const headerContainerStyles = `flex items-center justify-center mt-[48px]`

export const footerDetailStyles = `text-sm-regular mb-8`

export const leftAlignedContainerStyles = `flex flex-col h-full w-full`

export const leftAlignedRightContainerStyles =
   'h-full flex-1 flex flex-col relative'

export const leftAlignedRightInnerContainerStyles =
   'flex-1 flex items-center justify-center'

export const posterImageStyles = 'w-full max-w-[630px] aspect-square'

export const leftAlignedLayoutFooterStyles =
   'absolute right-[64px] bottom-0 text-right'
